import { Link } from 'react-router-dom';
import type { Issue } from '../api/types';
import { SeverityBadge, StatusBadge } from './Badge';

function timeAgo(iso: string): string {
  const d = new Date(iso);
  const diffSec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diffSec < 60) return `${diffSec}s`;
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h`;
  return `${Math.floor(diffSec / 86400)}d`;
}

export function IssueRow({ issue }: { issue: Issue }) {
  return (
    <Link to={`/i/${issue.id}`} className="issue-row">
      <span className="id">#{String(issue.id).padStart(3, '0')}</span>
      <SeverityBadge severity={issue.severity} />
      <span className="title">{issue.title}</span>
      <span className="meta">
        <StatusBadge status={issue.status} />
        {issue.component && <span>{issue.component}</span>}
        <span>{timeAgo(issue.created_at)}</span>
      </span>
    </Link>
  );
}
